<template>
  <path
    class="c1"
    d="M7.55483 52.2086C3.5069 45.3791 2.09098 37.307 3.5729 29.5075C5.05481 21.7081 9.33264 14.7178 15.6033 9.84884C21.8739 4.97993 29.7061 2.56729 37.6296 3.06385C45.553 3.56041 53.0227 6.93203 58.6364 12.5457C64.2501 18.1594 67.6217 25.6291 68.1183 33.5526C68.6149 41.476 66.2022 49.3082 61.3333 55.5789C56.4644 61.8495 49.4741 66.1273 41.6746 67.6093C33.8752 69.0912 25.803 67.6753 18.9736 63.6273V63.6273L7.69076 66.8219C7.2285 66.9571 6.73838 66.9654 6.27177 66.8461C5.80516 66.7267 5.37926 66.484 5.03869 66.1435C4.69813 65.8029 4.45545 65.377 4.33609 64.9104C4.21673 64.4438 4.22509 63.9536 4.36029 63.4914L7.55483 52.2086Z"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    class="c2"
    d="M35.626 39.634C37.8783 39.634 39.7041 37.8082 39.7041 35.5559C39.7041 33.3036 37.8783 31.4778 35.626 31.4778C33.3737 31.4778 31.5479 33.3036 31.5479 35.5559C31.5479 37.8082 33.3737 39.634 35.626 39.634Z"
    :fill="iconColor"
  />
  <path
    class="c2"
    d="M19.3135 39.634C21.5658 39.634 23.3916 37.8082 23.3916 35.5559C23.3916 33.3036 21.5658 31.4778 19.3135 31.4778C17.0612 31.4778 15.2354 33.3036 15.2354 35.5559C15.2354 37.8082 17.0612 39.634 19.3135 39.634Z"
    :fill="iconColor"
  />
  <path
    class="c2"
    d="M51.9385 39.634C54.1908 39.634 56.0166 37.8082 56.0166 35.5559C56.0166 33.3036 54.1908 31.4778 51.9385 31.4778C49.6862 31.4778 47.8604 33.3036 47.8604 35.5559C47.8604 37.8082 49.6862 39.634 51.9385 39.634Z"
    :fill="iconColor"
  />
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      required: false,
      default: "black",
    },
    iconBorder: {
      type: String,
      required: false,
      default: "black",
    },
  },
};
</script>

<style scoped>
  path {
    font-family: var(--iconFontFamily);
    font-size: var(--iconFontSize);
  }

  .c2 {
    fill:var(--iconColor)
  }

  .c1 {
    stroke:var(--iconColor)
  }

  .group:hover .group-hover\:text-hoverIcon  .c2{
    fill:var(--iconHoberColor)
  }

  .group:hover .group-hover\:text-hoverIcon  .c1 {
    stroke:var(--iconHoberColor)
  }
</style>